module.exports = __webpack_public_path__ + "img/chess_japanchess12.a0b9a796.png";